import React from 'react';
import { Bell, Home, BookOpen, BarChart2, Award, Settings, Plus, Menu } from 'lucide-react';
interface HeaderProps {
  onOpenSidebar?: () => void;
}
export function Header({
  onOpenSidebar
}: HeaderProps) {
  return;
}
function NavItem({
  icon,
  label,
  active = false
}) {
  return <div className={`flex items-center cursor-pointer ${active ? 'text-red-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1485" data-mp="2nkak8yo2355g">
      <span className="mr-2" data-id="element-1486" data-mp="2rmxc2zkq8q2n">{icon}</span>
      <span className="text-sm" data-id="element-1487" data-mp="2rk2v5i0x9ndz">{label}</span>
    </div>;
}